import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pass2",
  "use": "icon-pass2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pass2\"><path d=\"M451.52 947.904C322.048 787.52 169.728 666.112 64 628.032l250.88-150.528 120.96 235.2s197.12-477.568 508.48-636.608c-6.72 113.792-37.632 212.352 15.68 333.76-136.64 30.912-417.088 371.84-508.48 538.048z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol